import { render, staticRenderFns } from "./IDGeneration.vue?vue&type=template&id=1846d688&scoped=true&"
import script from "./IDGeneration.vue?vue&type=script&lang=js&"
export * from "./IDGeneration.vue?vue&type=script&lang=js&"
import style0 from "./IDGeneration.vue?vue&type=style&index=0&id=1846d688&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1846d688",
  null
  
)

export default component.exports